import { LANG_FR_BE, blogPath, pressPath } from "../../../constants";
import { t } from "../../../translations";

const locale = LANG_FR_BE;

export const otherMenuItems = [
  {
    name: t(locale, "navigation.news"),
    description: "",
    href: blogPath({ locale }),
  },
  {
    name: t(locale, "press.title"),
    description: "",
    href: pressPath({ locale }),
  },
];
